<template>
  <BaseCard width="600" :key="key">
    <v-form ref="form" class="d-flex flex-wrap align-center justify-space-between">
      <BaseInput
        :label="localStorage.translations.pages['setting-setting_company'].all['calendar_editing']"
        v-model="edit_report_days"
        input-type="number"
        :rules="['required']"
        :view-value="edit_report_days + ' ' + localStorage.translations.pages['common'].measure.days"
        :view="!edit"
      >
        <div slot="append-outer" class="mt-1">
          {{ localStorage.translations.pages['common'].measure.days }}
        </div>
      </BaseInput>
    </v-form>
    <div class="fixedBtn">
      <BaseTooltip v-if="edit" :tooltip="localStorage.translations.pages.common['buttons']['sohranit']">
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip v-else :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']">
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit"/>
      </BaseTooltip>
    </div>
  </BaseCard>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BaseCard from "components/base/BaseCard";
import BaseInput from "components/base/BaseInput";

export default {
  name: 'settingCompanyCalendar',
  components: {BaseInput, BaseCard},
  data: () => ({
    key: 0,
    edit_report_days: 0
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    edit() {
      return this.$route.name === 'SettingCompanyCalendarEdit'
    },
    notification() {
      return this.localStorage.translations.pages.common.notifications
    },
  },
  created() {
    this.onLoadData()
  },
  watch: {
    edit_report_days() {
      if (this.edit) this.onInput()
    },
    '$route.name'() {
      this.onCheckChange({overwrite: true})
    }
  },
  methods: {
    ...mapActions('commonConfig', ['onCommonConfigSettings', 'onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onCheckChange({overwrite}) {
      this.onNavigationGuardianCheck({
        data: {calendar: {value: this.edit_report_days}},
        overwrite,
      })
    },
    onInput() {
      this.onCheckChange({overwrite: false})
    },
    async onLoadData() {
      await this.onCommonConfigSettings({name: 'report'})
        .then(res => {
          this.edit_report_days = res.data.edit_report_days
          this.key++
          if (this.edit) this.onCheckChange({overwrite: true})
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.notification['oshibka'], IsError: false},
            {root: true},
          )
        })
    },
    onEdit() {
      this.$router.push({name: this.edit ? 'SettingCompanyCalendar' : 'SettingCompanyCalendarEdit'})
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        await this.onCommonConfigSettingsUpdate({
          name: 'report',
          data: {edit_report_days: this.edit_report_days},
          notCommitToMain: true
        })
          .then(() => {
            this.onLoadData()
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['izmeneniya-uspeshno-sohraneny'], IsError: false},
              {root: true},
            )
            setTimeout(() => {
              this.onEdit()
            }, 300)
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['oshibka'], IsError: false},
              {root: true},
            )
          })
      }
    },
  },
}
</script>
